import * as React from 'react';

import { BaseComponent } from './BaseComponent';
import { LayoutType } from '../constants/LayoutConstants';
import { PopupMenu } from '../constants/Enums';
import { DoneMessageSetting, VisibilityStore } from '../stores/VisibilityStore';
import { ViewSettingsStore } from '../stores/ViewSettingsStore';
import { AppConfigurationStore } from '../stores/AppConfigurationStore';
import { GlobalHelper } from '../utils/GlobalHelper';
import { ViewSettingsActions } from '../actions/ViewSettingsActions';
import { VisibilityActions } from '../actions/VisibilityActions';
import { DoneMessage } from './DoneMessage';

import utils = egr.wcf.utils;

interface ViewerContainerProps {
    layoutType: LayoutType;
    noBars: boolean;
    popup: PopupMenu;
}

interface ViewerContainerState {
    dragMode: boolean;
    doneMessage: DoneMessageSetting;
    infoMessage: string;
}

export class ViewerContainer extends BaseComponent<ViewerContainerProps, ViewerContainerState> {
    protected lastDown: {x: number, y: number} | undefined;
    protected lastTimeout: number | null = null;

    public componentWillMount(): void {
        this.addStoreListener(ViewSettingsStore, this.onChange);
        this.addStoreListener(VisibilityStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element {
        return (
            <div
                id="viewer-container"
                className={this.getClassName()}
                onTouchStart={this.touchStart}
                onTouchEnd={this.touchEnd}
                onClickCapture={this.closePopups}
            >
                {this.infoMessage()}
                {!utils.string.isNullOrEmpty(this.state.doneMessage.label) &&
                    <DoneMessage label={this.state.doneMessage.label} key={this.state.doneMessage.id}/>
                }
            </div>
        );
    }

    protected getClassName = (): string => {
        const base: string = 'viewer-container';
        let result: string = base;
        if (this.state.dragMode) {
            result += ` ${base}-dragcursor`;
        }
        return result;
    };

    protected infoMessage = (): JSX.Element | null => {
        if (utils.string.isNullOrEmpty(this.state.infoMessage)) {
            return null;
        }

        const inApp: boolean = AppConfigurationStore.getState().inApp;
        const infoMessageBaseClass: string = 'view-footer-info';

        return (
            <div
                onClick={GlobalHelper.stopActiveTool}
                className={inApp ? `${infoMessageBaseClass} ${infoMessageBaseClass}-in-app` : infoMessageBaseClass}
            >
                <span>{this.state.infoMessage}</span>
            </div>
        );
    };

    protected onChange = (): void => {
        const { doneMessage, infoMessage } = VisibilityStore.getState();
        this.setState({
            dragMode: ViewSettingsStore.getState().dragMode,
            doneMessage,
            infoMessage,
        });
    };

    protected toggleBars = () => {
        if (GlobalHelper.coreApp.model.selection[0] == null && this.props.layoutType === LayoutType.SMALL && AppConfigurationStore.getState().inApp) {
            if (this.props.noBars) {
                ViewSettingsActions.showBars();
            } else {
                ViewSettingsActions.hideBars();
            }
        } else if (GlobalHelper.coreApp.model.selection[0] != null) {
            ViewSettingsActions.showBars();
        }
        this.lastTimeout = null;
    };

    protected touchStart = (pEvent: React.TouchEvent) => {
        if (
            pEvent.changedTouches.length &&
            GlobalHelper.coreApp.model.selection[0] == null
        ) {
            this.lastDown = {x: pEvent.changedTouches[0].clientX, y: pEvent.changedTouches[0].clientY};
        }
    };

    protected touchEnd = (pEvent: React.TouchEvent) => {
        this.closePopups();
        if (this.lastTimeout != null) {
            window.clearTimeout(this.lastTimeout);
            this.lastTimeout = window.setTimeout(() => { this.lastTimeout = null; }, 200);
        } else if (
            pEvent.changedTouches.length &&
            this.lastDown != null &&
            pEvent.changedTouches[0].clientX === this.lastDown.x &&
            pEvent.changedTouches[0].clientY === this.lastDown.y
        ) {
            this.lastTimeout = window.setTimeout(this.toggleBars, 200);
        }
    };

    protected closePopups = (): void => {
        if (
            this.props.popup != null &&
            this.props.popup !== PopupMenu.NONE &&
            [
                PopupMenu.FLOORPLAN_SETUP,
                PopupMenu.SOLIDFLOOR_SETUP,
                PopupMenu.TOOLS_SETUP,
                PopupMenu.ENVIRONMENT_FLOORPLAN_SETUP
            ].indexOf(this.props.popup) === -1
        ) {
            VisibilityActions.setPopupMenu(PopupMenu.NONE);
        }
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ViewerContainer.tsx